function flattenObject(src, separator = '.', valueFilters = []) {
	let result = {};
	let queue = [{ obj: src, path: [] }];
	let entry;

	while ((entry = queue.pop())) {
		let parentPath = entry.path;
		let obj = entry.obj;

		for (let key in obj) {
			if (obj.hasOwnProperty(key)) {
				let val = obj[key];
				let path = parentPath.concat(key);

				if (val !== null && !Array.isArray(val) && typeof val === 'object') {
					queue.push({ obj: val, path });
				} else {
					if (!valueFilters.some(valueFilter => valueFilter(val))) {
						result[path.join(separator)] = val;
					}
				}
			}
		}
	}

	return result;
}

export default flattenObject;
